import React from "react";

const PlotlyIconBase = ({
  children,
  size,
  style = {},
  ...props
}: {
  children: any;
  size: number;
  style: any;
}) => {
  return (
    <svg
      children={children}
      fill="currentColor"
      preserveAspectRatio="xMidYMid meet"
      style={style}
      {...props}
    />
  );
};

export default PlotlyIconBase;
